shadow$provide[179] = function(require,module,exports) {
var require$_DOT__SLASH_attributes_DOT_js = require("./attributes.js");
var require$_DOT__SLASH_group_DOT_js = require("./group.js");
var require$_DOT__SLASH_guard_DOT_js = require("./guard.js");
var require$_DOT__SLASH_model_DOT_js = require("./model.js");
var require$_DOT__SLASH_node_DOT_js = require("./node.js");
require.exportCopy(module, require$_DOT__SLASH_attributes_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_group_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_guard_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_model_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_node_DOT_js);

};